import axios from 'axios';

export const getDates = () => axios(`${process.env.REACT_APP_DATE_API_URL}`);

export default { getDates };
